webpackJsonp([24],{

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation', 'selectList']);
mc.runComponents(['rating']);
mc.runFooter();

$('body').on('ajaxResponse', function () {
	mc.runVue(['selectList']);
});

/***/ })

},[92]);


// WEBPACK FOOTER //
// bundles/contact.bundle.js